<div #navGroupRef
     class="go-nav-group"
     [ngClass]="{ 'go-nav-group--expanded': group.expanded }"
     *ngIf="group.subRoutes && group.subRoutes.length > 0; else noSubRoutes">
  <div class="go-nav-group__dropdown"
       (click)="expand(group)"
       [attr.title]="group.description"
       [ngClass]="{ 'go-nav-group__dropdown--expanded': group.expanded, 'go-nav-group__dropdown--first': index === 0 }">
    <div class="go-nav-group__link">
      <span class="go-nav-group--selected"
            [ngStyle]="{ 'background': brandColor }"
            *ngIf="level === 0 && navItem.routeActive"></span>
      <go-icon [icon]="navItem.routeIcon"
               class="go-nav-group__icon"
               *ngIf="navItem.routeIcon">
      </go-icon>
      <span class="go-nav-group__title" *ngIf="navService.navOpen">
        {{ navItem.routeTitle }}
      </span>
    </div>
    <go-icon
      class="go-nav-group__expand-icon"
      icon="expand_more"
      *ngIf="navService.navOpen"
      [ngClass]="{ 'go-nav-group__expand-icon--expanded': group.expanded }">
    </go-icon>
  </div>
  <div *ngIf="group.expanded">
    <div *ngFor="let item of group.subRoutes">
      <go-nav-group *ngIf="item.subRoutes; else subRoutesElse"
                    class="go-nav-group__inner-group"
                    [navItem]="item"
                    [level]="level + 1">
      </go-nav-group>
      <ng-template #subRoutesElse>
        <go-nav-item [navItem]="item" [level]="level + 1"></go-nav-item>
      </ng-template>
    </div>
  </div>
</div>
<ng-template #noSubRoutes>
  <go-nav-item
    [navItem]="navItem"
    [level]="level"
    [ngClass]="{ 'go-nav-item--first': index === 0 }">
  </go-nav-item>
</ng-template>
